import { ProjectionKind, useMySessionsDataTable } from 'generated/resources/datatable.graphql'
import moment from 'moment'

import DataTable from 'modules/core/components/DataTable'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

interface Props {
  trainingId: number
}

export const CatalogSessionsDataTable = ({ trainingId }: Props) => {
  const { debouncedSearch, search, onSearch } = useDebouncedSearch()
  const variables = { search: debouncedSearch, trainingId: trainingId }
  const source = useMySessionsDataTable(
    [
      {
        identifier: 'name',
        kind: ProjectionKind.Path,
        title: i18n.t('trainings.trainings_table.name'),
        path: 'name',
      },
      {
        identifier: 'startsAt',
        kind: ProjectionKind.Custom,
        title: i18n.t('trainings.sessions_table.starts_at'),
        render: ({ startsAt }) =>
          startsAt
            ? moment(startsAt).format('L HH:mm').toLocaleString()
            : i18n.t('trainings.my_training.next_session.self_paced'),
        template: '{{ startsAt }}',
      },
      {
        identifier: 'endsAt',
        kind: ProjectionKind.Custom,
        title: i18n.t('trainings.sessions_table.ends_at'),
        render: ({ endsAt }) =>
          endsAt
            ? moment(endsAt).format('L HH:mm').toLocaleString()
            : i18n.t('trainings.my_training.next_session.self_paced'),
        template: '{{ endsAt }}',
      },
    ],
    {
      variables: variables,
    }
  )

  return (
    <DataTable
      source={source}
      disableDefaultActions
      search={{
        placeholder: i18n.t('common.search'),
        value: search,
        onChange: onSearch,
      }}
    />
  )
}
